/** Wortmarke (design.md §8): Kiste aus Quadrat, waagerechter Teilung und Schloss, daneben der Name. */
export function BrandMark({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden>
      <rect x="1.5" y="2.5" width="13" height="11" fill="none" stroke="var(--accent)" strokeWidth="1.5" />
      <path d="M1.5 7h13" stroke="var(--accent)" strokeWidth="1.5" />
      <rect x="6.5" y="5.5" width="3" height="3.5" fill="var(--accent)" />
    </svg>
  );
}

export function Brand() {
  return (
    <div className="brand">
      <BrandMark />
      <span>Chest Catalog</span>
    </div>
  );
}
